// extracted by mini-css-extract-plugin
export var option = "_4g-1";
export var optionActive = "_4g-2";
export var pill = "_4g-0";